import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PageActions, Toast, Frame } from '@shopify/polaris';

import axiosRails from '@utils/axios';

const defaultError = I18n.t("actions.default_error");

const propTypes = {
  onPrimaryAction: PropTypes.func,
  loading: PropTypes.bool,
  deleteURL: PropTypes.string,
  deleteText: PropTypes.string,
  disabled: PropTypes.bool,

  primaryActionURL: PropTypes.string,
  primaryActionTitle: PropTypes.string,

  httpMethod: PropTypes.string,
};

const defaultProps = {
  httpMethod: "DELETE",
  disabled: false,
}
class FormPageActions extends Component {
  state = {
    localLoading: false,
    showToast: false,
    toastMessage: "",
  }
  render() {
    const { localLoading, showToast, toastMessage } = this.state;
    const props = this.props;
    return (
      <div className="mt10">
          <PageActions
            primaryAction={ (props.onPrimaryAction || props.primaryActionURL) ? {
              content: props.primaryActionTitle || I18n.t("actions.save"),
              loading: props.loading || localLoading,
              disabled: props.disabled,
              url: props.primaryActionURL,
              onAction: props.onPrimaryAction
            } : null }

            secondaryActions={ props.deleteURL ? [
              {
                content: props.deleteText || I18n.t("actions.delete"),
                destructive: true,
                loading: props.loading || localLoading,
                onAction: this.handleDelete,
              },
            ] : null }
          />
          { showToast ?
            <Toast
              content={toastMessage}
              onDismiss={this.toggleToast} />
            : null
          }
      </div>
    );
  }

  handleDelete = async () => {
    if (confirm('Esta acción es irreversible, continuar?')) {
        // Save it!
      await this.setState({ localLoading: true });
      try {
        const response = await  axiosRails({
          method: this.props.httpMethod,
          url: this.props.deleteURL,
        });
        const { data } = response;
        if(data.success){
          alert(data.message || "Eliminado con éxito");
          window.location = data.redirectURL;
        }
        else{
          await this.setState({
            showToast: true,
            toastMessage: data.message || (data.errors && data.errors.base) || defaultError
          })
        }
      } catch (error) {
        alert("Ocurrio un error.")
        console.log("FPA - Catch error", error)
      }
      await this.setState({ localLoading: false });
    } else {
      // Do nothing!
    }
  }

  toggleToast = () => {
    this.setState(({showToast}) => ({showToast: !showToast}));
  };
}


FormPageActions.propTypes = propTypes;

FormPageActions.defaultProps = defaultProps;

export default FormPageActions;
